import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=321a7609&"
import script from "./BaseLabel.vue?vue&type=script&lang=js&"
export * from "./BaseLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports